module.exports = __webpack_public_path__ + "static/media/internal_error.5cf022de.png";